<template>
	<ConsoleEventArg renderAs="ArgObject" :value="asObject" :serialized="serialized">Map</ConsoleEventArg>
</template>

<script>
export default {
	name: 'ArgMap',
	props: {value: Object, serialized: Object},
	computed: {
		asObject() {
			const data = this.value.data
			const obj = {}
			for (var i = 0; i < data.length; i += 2) {
				obj[data[i]] = data[i + 1]
			}
			return obj
		},
	},
}
</script>
